import { env } from '@cc-shopping/platform-env';

export function getABSmartlyEnvironment() {
  return env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'preview-wp-production'
    ? 'stage'
    : env.NEXT_PUBLIC_DEPLOYABLE_ENV;
}
